import { useEffect, useMemo } from 'react'

import { UseFormReturn } from 'react-hook-form'

import { UsersUpdateFragment } from '@gql/graphql'

import { TUserNotificationsForm } from '@/forms/types'

interface IUseUserNotificationsResetFormParams {
  form: UseFormReturn<TUserNotificationsForm>
  user: UsersUpdateFragment | undefined
}

export const useUserNotificationsReset = ({ form, user }: IUseUserNotificationsResetFormParams) => {
  const userValues = useMemo(() => {
    return {
      enableJobNotifications: user?.enableJobNotifications,
      enableJobRecommendationsNotifications: user?.enableJobRecommendationsNotifications,
    }
  }, [user])

  useEffect(() => {
    form.reset({
      ...form.formState.defaultValues,
      enableJobNotifications: userValues.enableJobNotifications,
      enableJobRecommendationsNotifications: userValues.enableJobRecommendationsNotifications,
    })
  }, [userValues, form, user])
}
